// Copyright (c) 2016 Deere & Company

import DemoRentalHistoryReport from './components/demo-rental-history-report';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {isDemoRentalReqCriteriaValid} from '../shared/services/criteria-validation';
import {mapBoundActionCreatorsToActionsProp} from '../../../src/shared/services/state-connector';

const getStateToBindToContainerProps = state => ({
    ...state.reports.demoRentalHistory,
    allowedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    isRequiredCriteriaValid: isDemoRentalReqCriteriaValid(state.reports.demoRentalHistory.criteria.dealers, state.reports.demoRentalHistory.criteria.status),
    layouts: state.reportVariant.layouts,
    selectedLayout: state.reportVariant.selectedLayout
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DemoRentalHistoryReport);



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/state-connector.js